import { Component } from 'react'

import { FilterBarTop } from './FilterBar/FilterBarTop'
import { FilterBarModal } from './FilterBar/FilterBarModal'
import { Search } from './FilterBar/Search'
import { Taxonomies } from './FilterBar/Taxonomies'

export class FilterBar extends Component {

	constructor(props) {
		super(props)

		this.state = {
			'mobileFiltersOpen': false
		}

		this.toggleMobileFilterBar = this.toggleMobileFilterBar.bind(this)
	}

	toggleMobileFilterBar() {
		this.setState({ mobileFiltersOpen: !this.state.mobileFiltersOpen })
		document.getElementById('program-finder-app').scrollIntoView();
	}

	render() {
		return (
			<div className={this.state.mobileFiltersOpen ? 'pf-filter-bar mobile-filter-open' : 'pf-filter-bar'}>
				<div className="pf-mobile">
					<Search filters={this.props.filters} updateFilter={this.props.updateFilter} />

					<button className="pf-show-filters" onClick={ this.toggleMobileFilterBar }>Show Filters</button>
				</div>

				<div className="pf-tablet">
					<FilterBarTop
						programsCount={this.props.programsCount}
						resetFilters={this.props.resetFilters}
					/>
					<Search filters={this.props.filters} updateFilter={this.props.updateFilter} />
					<Taxonomies
						taxonomies={this.props.taxonomies}
						filters={this.props.filters}
						updateFilter={this.props.updateFilter}
						showTaxList={false}
					/>
				</div>
					
				<FilterBarModal
					taxonomies={this.props.taxonomies}
					filters={this.props.filters}
					updateFilter={this.props.updateFilter}
					showTaxList={false}
					isOpen={ this.state.mobileFiltersOpen }
					resetFilters={ this.props.resetFilters }
					closeModal={ this.toggleMobileFilterBar }
				/>
			</div>
		)
	}

}